export default class UploadAdapter {
  constructor(loader) {
    // The file loader instance to use during the upload.
    this.loader = loader
    this.aborted = false
  }

  // Starts the upload process.
  upload() {
    return this.loader.file
      .then(file => new Promise((resolve, reject) => {
        if (this.aborted) { reject(new Error('Upload cancelled')); return }
        if (!file) { reject(new Error('No file selected')); return }
        this.initRequest()
        this.initListeners(resolve, reject, file)
        this.sendRequest(file)
      }))
  }

  // Aborts the upload process.
  abort() {
    this.aborted = true
    if (this.xhr) {
      this.xhr.abort()
    }
  }

  // Initializes the XMLHttpRequest object using the URL passed to the constructor.
  initRequest() {
    const xhr = new XMLHttpRequest()
    this.xhr = xhr

    xhr.open('POST', `${process.env.VUE_APP_BASE_URL}/files/file`, true)
    xhr.timeout = 120000
    xhr.setRequestHeader('Authorization', localStorage.getItem('accessToken'))
  }

  // Initializes XMLHttpRequest listeners.
  initListeners(resolve, reject, file) {
    const { xhr } = this
    const { loader } = this
    const genericErrorText = `Couldn't upload file: ${file.name}.`

    xhr.addEventListener('error', () => reject(genericErrorText))
    xhr.addEventListener('abort', () => reject())
    xhr.addEventListener('timeout', () => reject(new Error('Upload outcome is unknown. Check the saved files before uploading again.')))
    xhr.addEventListener('load', () => {
      const { response } = xhr

      if (xhr.status < 200 || xhr.status >= 300 || !response) {
        reject(new Error(genericErrorText))
        return
      }

      try {
        const resource = typeof response === 'string' ? JSON.parse(response) : response
        const base = new URL(resource.baseUrl)
        const local = ['127.0.0.1', 'localhost'].includes(base.hostname)
        if ((base.protocol !== 'https:' && !(local && base.protocol === 'http:')) || base.username || base.password || base.search || base.hash || base.pathname !== '/'
          || resource.bucketName !== 'public' || typeof resource.type !== 'string'
          || !/^[a-zA-Z][a-zA-Z0-9]*$/.test(resource.type)
          || resource.destination !== `${resource.type}/`
          || !/^[a-zA-Z0-9_.-]+$/.test(resource.filename || '') || resource.filename.includes('..')) throw new Error('Invalid upload response')
        resolve({ default: `${base.href.replace(/\/$/, '')}/public/${resource.destination}${resource.filename}` })
      } catch (_) {
        reject(new Error(genericErrorText))
      }
    })

    if (xhr.upload) {
      xhr.upload.addEventListener('progress', evt => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total
          loader.uploaded = evt.loaded
        }
      })
    }
  }

  // Prepares the data and sends the request.
  sendRequest(file) {
    // Prepare the form data.
    const data = new FormData()

    data.append('file', file)
    data.append('type', 'articleCoverImage')
    data.append('alt', 'articleImage')

    // Send the request.
    this.xhr.send(data)
  }
}

export const uploader = function (editor) {
  const repository = editor.plugins.get('FileRepository')
  repository.createUploadAdapter = loader => new UploadAdapter(loader)
}
